// React
import React, { useMemo, useState, useEffect } from "react";

// Styled components
import { ApplicantContactInfoWrapper } from "./ApplicantContactInfo.styled";
import { Flex } from "../../../style";
import { Grid, Row } from "../../../../components/Grid";

// Components
import { Icon } from "../../../../components";
import { Typography } from "../../../../components/Typography";
import { FileDownload } from "../../../../components";
import { ShimmerText } from "../../../../recruiter/components/Shimmer/Shimmer";

export const NON_ATTACHED_DOC_TYPES = ["profileImage", "personalityTest", "skillTest"];

const parseApplicationData = (data) => {
  if (!data) {
    return {
      applicant: {
        candidate: {},
      },
      links: {},
      files: [],
    };
  }

  let returnData;

  if (data.applicant) {
    returnData = { ...data, ...data.applicant.candidate };
  } else {
    returnData = data;
  }
  return returnData;
};

export const ApplicantContactInfo = ({ single, hideOnDesktop, isAnonymous, onUpdateState, loading }) => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 992);

  const handleResize = () => {
    setIsLargeScreen(window.innerWidth > 992);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const applicationData = parseApplicationData(single);
  const { files } = applicationData;
  const candidate = applicationData.applicant?.candidate || {};
  const links = applicationData.links || {};
  const documents = useMemo(() => {
    if (!files || files.length === 0) {
      return [];
    }

    return files
      .filter((file) => NON_ATTACHED_DOC_TYPES.indexOf(file.docType) === -1)
      .map((file) => {
        return { name: file.filename, url: file.signedRequest };
      });
  }, [files]);

  const copyConfirmation = () => {
    if (!onUpdateState) {
      return;
    }

    onUpdateState(true);
    setTimeout(() => {
      onUpdateState(false);
    }, 3500);
  };

  return (
    <>
      <ApplicantContactInfoWrapper hideOnDesktop={hideOnDesktop} isAnonymous={isAnonymous}>
        {loading ? (
          <Grid fluid>
            <Row mt={30} mr={0} ml={0}>
              <ShimmerText words={3} tag="p" fontSize="16" />
              <ShimmerText words={2} tag="p" fontSize="16" />
            </Row>
          </Grid>
        ) : null}
        {candidate.email && (
          <>
            <button className="btn" onClick={() => (window.location = `mailto:${candidate.email}`)}>
              <Flex flexDirection="row" align="center" justify="flex-start" ml="-2">
                <Icon width="40" mr="0" ml="-10" lowOpacity icon="email" />
                <Typography tag="p" lowOpacity nomargin large pointer>
                  {isLargeScreen && candidate.email.length > 15 ? `${candidate.email.slice(0, 15)}....` : candidate.email}
                </Typography>
              </Flex>
            </button>
            <Icon
              icon="clip"
              clip="true"
              scale="0.2"
              lowOpacity
              pointer
              onClick={() => {
                copyConfirmation();
                // Logic to copy the email to clipboard
                navigator.clipboard.writeText(candidate.email);
              }}
            />
          </>
        )}
        {candidate.phoneNumber && (
          <button className="btn" onClick={() => (window.location = `tel:${candidate.phoneNumber}`)}>
            <Flex flexDirection="row" align="center" justify="flex-start" ml="-2">
              <Icon width="40" ml="-10" mr="0" lowOpacity icon="phone" />
              <Typography tag="p" lowOpacity nomargin large pointer>
                {candidate.phoneNumber}
              </Typography>
            </Flex>
          </button>
        )}

        {candidate.city && (
          <Flex flexDirection="row" align="center" justify="flex-start" ml="-2" mb="10">
            <Icon width="40" mr="0" ml="-10" lowOpacity icon="marker" />
            <Typography tag="p" lowOpacity nomargin large>{`${candidate.city}, ${candidate.country}`}</Typography>
          </Flex>
        )}
        {links.linkedin && (
          <>
            <button className="btn" onClick={() => (window.location = `${links.linkedin}`)}>
              <Flex flexDirection="row" align="center" justify="flex-start" ml="-2">
                <Icon width="40" ml="-10" mr="0" lowOpacity icon="socials" />
                <Typography tag="p" lowOpacity nomargin large pointer>
                  {links.linkedin}
                </Typography>
              </Flex>
            </button>
          </>
        )}

        {links.other && (
          <>
            <button className="btn" onClick={() => (window.location = `${links.other}`)}>
              <Flex flexDirection="row" align="center" justify="flex-start" ml="-2">
                <Icon width="40" mr="0" ml="-10" lowOpacity icon="website" />
                <Typography tag="p" lowOpacity nomargin large pointer>
                  {links.other}
                </Typography>
              </Flex>
            </button>
          </>
        )}

        {documents.length > 0 && (
          <>
            {documents.map((doc, index) => (
              <FileDownload cv includeIcon key={index} url={doc.url} name={doc.name} />
            ))}
          </>
        )}
      </ApplicantContactInfoWrapper>
    </>
  );
};
